
import { supabase } from "@/integrations/supabase/client";
import { Business } from "@/components/business/BusinessCard";

export const fetchBusinessListings = async (): Promise<Business[]> => {
  const { data, error } = await supabase
    .from('business_listings')
    .select('*')
    .order('created_at', { ascending: false });
    
  if (error) {
    console.error("Error fetching business listings:", error);
    throw error;
  }
  
  // Fetch reviews for all businesses to calculate ratings
  const businessIds = data.map(business => business.id);
  const { data: reviewsData, error: reviewsError } = await supabase
    .from('business_reviews')
    .select('business_id, rating')
    .in('business_id', businessIds);
    
  if (reviewsError) {
    console.error("Error fetching reviews:", reviewsError);
    throw reviewsError;
  }
  
  // Calculate average rating for each business
  const reviewsByBusiness = reviewsData.reduce((acc, review) => {
    if (!acc[review.business_id]) {
      acc[review.business_id] = { sum: 0, count: 0 };
    }
    acc[review.business_id].sum += review.rating;
    acc[review.business_id].count += 1;
    return acc;
  }, {});
  
  // Add average ratings to business listings
  return data.map(business => {
    const reviews = reviewsByBusiness[business.id];
    let reviewsAvg = business.rating || 0;
    let reviewsCount = 0;
    
    if (reviews && reviews.count > 0) {
      reviewsAvg = parseFloat((reviews.sum / reviews.count).toFixed(1));
      reviewsCount = reviews.count;
    }
    
    return {
      ...business,
      reviewsAvg,
      reviewsCount
    };
  });
};
